import { axios } from '@Root/API'

export const get = () => {
	return axios.get('table-manager/additional-fields')
}
